export function getPriceWithMarkup(ticketPrice, maxTicketPrice) {
    var is_self_paying = localStorage.getItem("is_self_paying");
    const maxPrice = parseFloat(maxTicketPrice);
    const price = parseFloat(ticketPrice);
    const margin = (price < maxPrice) && is_self_paying == 0 ? 0.30 : 0;
    let finalPrice = price * (1 + margin);
    if (finalPrice > maxPrice && price < maxPrice) {
        finalPrice = maxPrice;
    }
    return parseFloat(finalPrice);
}
export function getTotalPriceWithMarkup(travelerPricings, maxTicketPrice) {
    var is_self_paying = localStorage.getItem("is_self_paying");
    var finalPrice = 0;
    travelerPricings.forEach(element => {
        const maxPrice = parseFloat(maxTicketPrice);
        const ticketPrice = parseFloat(element.price.total);
        const margin = (ticketPrice < maxPrice) && is_self_paying == 0 ? 0.30 : 0;
        let price = ticketPrice * (1 + margin);
        if (price > maxPrice && ticketPrice < maxPrice) {
            price = maxPrice;
        }
        finalPrice += price;
    });
    return (finalPrice);
}